module.exports = __webpack_public_path__ + "static/media/Assignment_Type_Customization_Greeting.97c337ac.svg";